module.exports = __webpack_public_path__ + "static/media/iconDownload2.9ca48297.svg";